<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-repeat`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.994 6.2a1.05 1.05 0 00-1.735-.676l-5.356 4.686-.087.086a1.05 1.05 0 00.087 1.494l5.356 4.686.096.076A1.05 1.05 0 0022 15.686V13h9c6.075 0 11 4.925 11 11 0 4.405-2.59 8.206-6.33 9.962l2.006 3.474C42.61 34.98 46 29.886 46 24c0-8.284-6.716-15-15-15h-9V6.314l-.006-.114zm-9.554 7.787l-2.007-3.477C5.44 12.945 2 18.071 2 24c0 8.284 6.716 15 15 15h9v2.686a1.05 1.05 0 001.741.79l5.356-4.686a1.05 1.05 0 000-1.58l-5.356-4.686a1.05 1.05 0 00-1.741.79V35h-9c-6.075 0-11-4.925-11-11a11 11 0 016.44-10.013z"/></svg>
</template>
<script>

export default {
  name: 'IconRepeat',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
